import { useParams } from 'react-router-dom';
import api from '../../services/api';
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { success } from "../global/ToastAlert";

const empty = {
    id: null,
    status: null,
    company_id: null,
    created: null,
    updated:null,
    customer_name: null,
    customer_surname: null,
    purchase_date_utc_ms: null,
    vendor_id: null,
    send_at: null,
    language: null,
    company_review_status: null,
    order_number: null,
    products: null,
    request_id: null
}

export const getEmptyInvitations = () => {
    return { ...empty };
}

export const useGetInvitations = () => {
    const { invitationId } = useParams();
    const fetchData = async () => {
        const { data } = await api.get(`/invitations/${invitationId}/form`)
        return data;
    };
    return useQuery({ queryKey: ['invitation', invitationId], queryFn: fetchData, enabled: true });
};


//https://www.artur.com/api/reviews/reviews/companies/98e20b6c-1e3a-4aa5-9374-902a393d7e5e
export const useInsertReview = () => {
    const { invitationId } = useParams();
    const queryClient = useQueryClient()
    const insertData = async ({data:insertData, message=null}) => {
        const { data } = await api.post(`/invitations/${invitationId}/review`, insertData);
        success(message);
        queryClient.invalidateQueries(['invitation', invitationId]);
        return data;
    };

    return useMutation(insertData);
};
